
/*
 * Public API Surface of mini-mat-table-exporter
 */

export * from './lib/mini-mat-table-exporter.module';
export { MatTableExporterDirective } from './lib/mini-mat-table-exporter.directive';
// export * from 'mini-cdk-table-exporter';
